import React from 'react';

import { useTranslation } from 'react-i18next';

import { YatLogo } from '@pkg/assets/brand';
import { Typography } from '@pkg/components';

import { StyledTypography, StyledYatHandWrap } from './styles';

const ICON_SIZE = '55px';

export function NoMatchingResults() {
    const { t: translate } = useTranslation(['yat_nft_manager']);
    return (
        <StyledYatHandWrap>
            <div>
                <YatLogo opacity={0.1} width={ICON_SIZE} height={ICON_SIZE} />
            </div>

            <StyledTypography type="headline">{translate('yat_nft_manager_no_results_title')}</StyledTypography>

            <Typography type="paragraph" color="grey">
                {translate('yat_nft_manager_change_filters')}
            </Typography>
        </StyledYatHandWrap>
    );
}
